import { render } from "./TemporaryNotification.vue?vue&type=template&id=78fab18f&scoped=true"
import script from "./TemporaryNotification.vue?vue&type=script&lang=js"
export * from "./TemporaryNotification.vue?vue&type=script&lang=js"

import "./TemporaryNotification.vue?vue&type=style&index=0&id=78fab18f&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fab18f"]])

export default __exports__